import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { Button } from '@saviynt/design-system';
import useStyles from './styles/DataTypeCard.styles';
import { BUTTON_LABELS, UI_LABELS } from '../../constants/stringConstants';

function DataTypeCard({
  title,
  description,
  onMigrate,
  isMigrating,
  isMigrateDisabled,
  status,
  children,
  disabled,
}) {
  const classes = useStyles();

  const cardClasses = [classes.card, disabled && classes.cardDisabled].filter(Boolean).join(' ');

  const getMigrateButtonLabel = () =>
    isMigrating ? BUTTON_LABELS.MIGRATING : BUTTON_LABELS.MIGRATE;

  const migrateButtonLabel = getMigrateButtonLabel();

  return (
    <div className={cardClasses}>
      <div className={classes.content}>
        <div className={classes.body}>
          <div className={`${classes.header} ${status ? classes.headerWithStatus : ''}`}>
            <div className={classes.typeSection}>
              <Typography variant="body2" className={classes.label}>
                {UI_LABELS.TYPE}
              </Typography>
              <Typography variant="h6" className={classes.title}>
                {title}
              </Typography>
            </div>
            <div className={classes.descriptionSection}>
              <Typography variant="body2" className={classes.label}>
                {UI_LABELS.DESCRIPTION}
              </Typography>
              <Typography variant="body2" className={classes.description}>
                {description}
              </Typography>
            </div>
          </div>
          {status && (
            <div
              className={`${classes.statusBox} ${
                status.success ? classes.statusSuccess : classes.statusError
              }`}>
              <Typography
                variant="body2"
                className={`${classes.statusText} ${
                  status.success ? classes.statusTextSuccess : classes.statusTextError
                }`}>
                {status.message}
              </Typography>
            </div>
          )}
          {children}
        </div>
        {onMigrate && (
          <div className={classes.buttonGroup}>
            <Button
              kind="outlined"
              size="small"
              onClick={onMigrate}
              isDisabled={disabled || isMigrateDisabled || isMigrating}
              className={classes.migrateButton}>
              {migrateButtonLabel}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}

DataTypeCard.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  onMigrate: PropTypes.func,
  isMigrating: PropTypes.bool,
  isMigrateDisabled: PropTypes.bool,
  status: PropTypes.shape({
    success: PropTypes.bool,
    message: PropTypes.string,
  }),
  children: PropTypes.node,
  disabled: PropTypes.bool,
};

DataTypeCard.defaultProps = {
  title: null,
  description: null,
  onMigrate: null,
  isMigrating: false,
  isMigrateDisabled: false,
  status: null,
  children: null,
  disabled: false,
};

export default DataTypeCard;
